/**
 * Market-specific content configuration
 */

export const marketContent = {
  bg: {
    companyName: 'Mind IT',
    logo: '/mindit-logo1-skyblue.png',
    logoAlt: 'Mind IT Logo',
    linkedin: 'https://www.linkedin.com/company/mindit-services/',
    teamName: 'Mind IT Team',
    tagline: 'Innovative IT Solutions Tailored for Your Business',
    description: 'Driving efficiency and growth through expert IT services and strategic advisory.',
    heroTitle: 'Innovative IT Solutions Tailored for Your Business',
    heroSubtitle: 'Driving efficiency and growth through expert IT services and strategic advisory.',
    ctaText: 'Schedule a Free Consultation',
    ctaUrl: 'https://outlook.office.com/owa/calendar/MindIT@mindit.bg/bookings/',
    foundingYear: '2013',
    location: 'Global',
    aboutText: 'Established in 2013, Mind IT is a forward-thinking IT Services and Advisory company serving global clients across industries. We deliver tailored solutions across on-premise, hybrid, and cloud-native infrastructures.',
    email: 'office@mindit.bg',
    phone: null,
    showPartnerLogos: true,
    targetAudience: 'enterprises and global clients',
    services: [
      {
        title: 'IT Consulting & Strategy',
        description: 'Crafting bespoke IT strategies aligned with your business goals.'
      },
      {
        title: 'Managed IT Services',
        description: 'Reliable support and infrastructure management for seamless operations.'
      },
      {
        title: 'Cloud Solutions',
        description: 'Scalable and secure cloud integration to elevate your digital capabilities.'
      },
      {
        title: 'Cybersecurity Services',
        description: 'End-to-end protection for your digital assets and sensitive data.'
      },
      {
        title: 'AI & Automation',
        description: 'Leverage AI to automate workflows and unlock data-driven insights.'
      },
      {
        title: 'Solutions for Small Business',
        description: 'Affordable, scalable IT solutions designed for growing businesses.'
      }
    ]
  },
  lu: {
    companyName: 'Mind IT Luxembourg',
    logo: '/mindit-logo1-skyblue.png',
    logoAlt: 'Mind IT Luxembourg Logo',
    linkedin: 'https://www.linkedin.com/company/mindit-services/',
    teamName: 'Mind IT Team',
    tagline: 'IT Solutions for Small & Micro Businesses',
    description: 'Streamline your business with modern cloud, AI, and cybersecurity solutions designed for Luxembourg SMBs.',
    heroTitle: 'Modern IT Solutions for Luxembourg Small Businesses',
    heroSubtitle: 'Fast-track your digital transformation with expert consulting, cloud migration, and AI automation.',
    ctaText: 'Get Your Free IT Assessment',
    ctaUrl: '/contact',
    foundingYear: '2026',
    launchDate: 'March 2026',
    location: 'Luxembourg',
    aboutText: 'Mind IT Luxembourg brings over a decade of IT expertise to the Luxembourg market, specializing in helping small and micro businesses modernize their technology infrastructure. We offer practical, cost-effective solutions that get you to the cloud faster.',
    email: 'office@mindit.lu',
    phone: null,
    showPartnerLogos: true,
    targetAudience: 'small and micro businesses',
    services: [
      {
        title: 'Free IT Assessment',
        description: 'Comprehensive review of your current IT setup with actionable recommendations.'
      },
      {
        title: 'Cloud Migration',
        description: 'Fast-track migration to Microsoft 365, AWS, or Azure with minimal disruption.'
      },
      {
        title: 'AI Consulting',
        description: 'Practical AI automation to reduce manual work and improve efficiency.'
      },
      {
        title: 'Managed IT Support',
        description: 'Reliable ongoing support to keep your business running smoothly.'
      }
    ]
  },
  mwo: {
    companyName: 'Modern Work Ops',
    logo: '/mwo-banner-header.svg',
    logoHeight: '70px',
    logoAlt: 'Modern Work Ops Logo',
    linkedin: 'https://www.linkedin.com/company/mw-ops/',
    teamName: 'Modern Work Ops Team',
    tagline: 'Modern IT Operations for Growing Businesses',
    description: 'Streamline your operations with modern cloud, AI, and cybersecurity solutions.',
    heroTitle: 'Modern IT Operations for Growing Businesses',
    heroSubtitle: 'Streamline your operations with expert cloud, AI, cybersecurity, and managed IT services.',
    ctaText: 'Schedule a Free Consultation',
    ctaUrl: '/contact',
    foundingYear: '2013',
    location: "15 rue de l'industrie L-8069 Bertrange, Luxembourg",
    aboutText: 'Modern Work Ops delivers expert IT services and advisory to businesses worldwide. With over a decade of experience, we specialise in cloud migration, AI automation, cybersecurity, and managed IT support.',
    email: 'hello@modernworkops.com',
    phone: null,
    showPartnerLogos: true,
    targetAudience: 'enterprises and global clients',
    services: [
      {
        title: 'IT Consulting & Strategy',
        description: 'Crafting bespoke IT strategies aligned with your business goals.'
      },
      {
        title: 'Managed IT Services',
        description: 'Reliable support and infrastructure management for seamless operations.'
      },
      {
        title: 'Cloud Solutions',
        description: 'Scalable and secure cloud integration to elevate your digital capabilities.'
      },
      {
        title: 'Cybersecurity Services',
        description: 'End-to-end protection for your digital assets and sensitive data.'
      },
      {
        title: 'AI & Automation',
        description: 'Leverage AI to automate workflows and unlock data-driven insights.'
      },
      {
        title: 'Solutions for Small Business',
        description: 'Affordable, scalable IT solutions designed for growing businesses.'
      }
    ]
  }
};

export const getMarketContent = (market) => marketContent[market] || marketContent.bg;
